function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 120.5c0-15.6-12.7-28.4-28.4-28.4h-14.2v-7.2c-.1-39-31.9-70.8-70.9-70.8h-56.7c-39.1 0-70.9 31.7-71 70.7V92H28.2C12.7 92.1 0 104.8 0 120.5v49.6c0 15.6 12.7 28.3 28.3 28.3h42.5l-.1-113.5c0-23.4 19.2-42.4 42.6-42.4H170c23.4 0 42.5 19.1 42.5 42.5v136.6l-35.4 11.8v-13.8h-56.7V248H178.2l48.5-16.1v-33.5H255c15.6 0 28.4-12.7 28.4-28.4l.1-49.5zM28.3 170.1v-49.7h14.1v49.7H28.3zm226.8 0h-14.2v-49.6h14.2v49.6z"
})));